import { LonaWebComponent, html } from "@tento-ui/component";
import { component } from "@tento-ui/component-decorators";
import { css, Style } from "@tento-ui/component-styles";
import { EditableText } from "@tento-ui/components/editable-text";
import type { Option, TaskCalendarItem } from "@tento-lona/sheets";

/** The details panel of an existing task, with its editable title. */
@component({ name: "std-existing-task-details" })
export class ExistingTaskDetails extends LonaWebComponent {
  #$title: EditableText = this.hydrate("title");

  bind(task: TaskCalendarItem, onTitleChanged: (title: string) => void): this {
    this.#$title.bind(task.title, "Untitled");
    this.#$title.enableEditing(true);
    // tento-ui-js's `EditableText` controller passes its ambient `Option`.
    this.#$title.controller.onEditingFinished = (newTitle: string | null | undefined) => {
      const title = newTitle?.trim() || task.title;
      if (title !== task.title) {
        onTitleChanged(title);
      }
    };
    return this;
  }

  connectedCallback(): void {
    super.connectedCallback();
    requestAnimationFrame(() => this.#$title.controller.focus());
  }

  static override $styles: Style.Compat[] = [
    css`
      :host {
        display: block;
      }

      #root {
        padding: 12px;
        gap: 8px;
      }

      #title {
        --font-size: var(--text-12px);
        width: 100%;
        color: var(--text-pri);
      }
    `,
  ];

  static override $html: Option<HTMLTemplateElement> = html`
    <std-col id="root">
      <std-editable-text id="title"></std-editable-text>
    </std-col>
  `;
}
